import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router";
import { connect } from "react-redux";
import { get_product } from "../../redux/actions/products";
import { add_item } from "../../redux/actions/cart";
import Layout from "../../hocs/Layout";
import ImageGallery from "../../components/product/ImageGallery";
import {
  IconCheck,
  IconX,
  IconInfoCircle,
  IconMinus,
  IconPlus,
} from "@tabler/icons-react";
import { Helmet } from "react-helmet";
import verifid from "../../assets/verificado.png";
import ChatBubble from "../../components/ChatBubble";
import { Link } from "react-router-dom";

const ProductDetail = ({ get_product, product, add_item }) => {
  const [modalStep, setModalStep] = useState(1);
  const [isAssistantLoading, setIsAssistantLoading] = useState(false);
  const [assistantData, setAssistantData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [openQuestion, setOpenQuestion] = useState(null);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const toggleModal = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setIsModalOpen(!isModalOpen);
  };
  const navigate = useNavigate();
  const { productId } = useParams();
  useEffect(() => {
    const storedProductId = localStorage.getItem("assistantProductId");
    const storedData = localStorage.getItem("assistantData");

    if (storedProductId === productId && storedData) {
      setAssistantData(JSON.parse(storedData));
    } else {
      // Si es distinto, limpiamos y esperamos una nueva petición
      localStorage.removeItem("assistantProductId");
      localStorage.removeItem("assistantData");
    }
  }, [productId]);

  useEffect(() => {
    window.scrollTo(0, 0);
    get_product(productId);
  }, [productId, get_product]);

  // Si el producto no está disponible aún, mostramos el loader.
  if (!product) {
    return (
      <Layout products={true}>
        <Helmet>
          <title>Histori AI - Load Product</title>
        </Helmet>
        <div className="relative bg-white pt-4 pb-8">
          <div className="max-w-7xl mx-auto px-4 flex items-center justify-center min-h-[80vh]">
            <div className="flex flex-col items-center">
              <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
              <p className="mt-4 text-gray-700">Load product...</p>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
  const openChat = () => {
    setIsChatOpen(true);
  };

  const addToCart = async () => {
    if (product?.quantity > 0) {
      setLoading(true);
      await add_item(product);
      setLoading(false);
      navigate("/cart");
    }
  };

  const buyNow = async () => {
    if (product?.quantity > 0) {
      setLoading(true);
      localStorage.removeItem("cart");
      await add_item(product);
      setLoading(false);
      navigate("/checkout");
    }
  };

  const toggleDropdown = (section) => {
    setOpenDropdown(openDropdown === section ? null : section);
  };

  const ConditionCircle = ({ condition, label, isActive }) => (
    <div className="flex flex-col items-center">
      <div className="mb-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          className="lucide lucide-square"
          style={{
            width: "2rem",
            height: "2rem",
            fill: isActive ? "#98D979" : "#C9C9C9",
            strokeWidth: 0,
          }}
        >
          <rect x="2" y="2" width="20" height="20" />
        </svg>
      </div>
      <span
        className={`text-center ${
          isActive ? "text-custom-green-button font-medium" : "text-black"
        }`}
      >
        {label}
      </span>
    </div>
  );

  return (
    <Layout products={true}>
      <Helmet>
        <title>
          {product ? `Histori AI - ${product.name}` : "Histori AI - Product"}
        </title>
        <meta
          name="description"
          content={
            product
              ? product.description
              : "Discover high-quality antiques at Histori.ai. Find what you're looking for among our various categories and products."
          }
        />

        <meta
          name="keywords"
          content="store, antiques, vintage, retro, quality, categories, products"
        />

        {/* Open Graph for Facebook and other networks */}
        <meta
          property="og:title"
          content={
            product
              ? `Histori.ai - ${product.name}`
              : "Histori.ai - Quality Antiques"
          }
        />

        <meta
          property="og:description"
          content={
            product
              ? product.description
              : "Discover high-quality antiques at Histori.ai. Find what you're looking for among our various categories and products."
          }
        />

        <meta
          property="og:image"
          content={
            product
              ? product.images[0]
              : "https://histori.ai/path/to/your-image.jpg"
          }
        />

        <meta property="og:url" content="https://histori.ai" />

        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content={
            product
              ? `Histori.ai - ${product.name}`
              : "Histori.ai - Quality Antiques"
          }
        />

        <meta
          name="twitter:description"
          content={
            product
              ? product.description
              : "Discover high-quality antiques at Histori.ai. Explore our categories and find the perfect product!"
          }
        />

        <meta
          name="twitter:image"
          content={
            product
              ? product.images[0]
              : "https://histori.ai/path/to/your-image.jpg"
          }
        />
      </Helmet>
      <div className="relative bg-white min-h-screen flex flex-col mt-4">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="w-full">
              <ImageGallery photos={product?.images} />
              <div className="flex justify-center mt-4">
                <button
                  onClick={openChat}
                  className="bg-white text-black px-4 py-2 rounded-full shadow-md hover:bg-green-400 transition-all"
                >
                  <span>"Who is this? AI"</span>
                </button>
              </div>
              <button
                type="button"
                onClick={(e) => toggleModal(e)}
                className="flex flex-col items-start w-full mt-4  text-white py-3 rounded-lg"
              >
                <img src={verifid} alt="Verificado" className="w-20 h-20" />
                <h3 className="text-md font-semibold text-gray-900">
                  Product Verified
                </h3>
              </button>
            </div>

            <div className="px-4">
              <h1 className="text-3xl font-extrabold text-gray-900">
                {product?.name}
              </h1>
              <p className="text-3xl text-gray-900 mt-3">{product.price
    ? `$${new Intl.NumberFormat('en-US').format(Math.floor(product.price))}`
    : " "}</p>
              <div className="mt-6 text-gray-700">
                <p className="font-bold">Description</p>
                <p>{product?.description}</p>
              </div>
              <div className="mt-6 text-gray-700 grid grid-cols-3 gap-4">
                {product?.type === "clothing" && (
                  <div>
                    <p className="font-bold">Size</p>
                    <p>
                      {product.size === "small"
                        ? "S"
                        : product.size === "medium"
                        ? "M"
                        : product.size === "large"
                        ? "L"
                        : product.size === "extra_large"
                        ? "XL"
                        : product.size}
                    </p>
                  </div>
                )}
                <div>
                  <p className="font-bold">Color</p>
                  <p>{product?.color}</p>
                </div>
                <div>
                  <p className="font-bold">Material</p>
                  <p>{product?.material}</p>
                </div>
              </div>

              <div className="mt-6">
                {(product?.type || product?.year) && (
                  <div className="mt-6 flex justify-between">
                    {product?.type && (
                      <div className="flex items-center">
                        <p className="font-bold mr-2">Type:</p>
                        <p>
                          {
                            {
                              clothing: "Clothing",
                              furniture: "Furniture",
                              jewelry: "Jewelry",
                              art: "Art",
                              books: "Books",
                              electronics: "Electronics",
                              collectibles: "Collectibles",
                            }[product.type]
                          }
                        </p>
                      </div>
                    )}
                    {product?.year && (
                      <div className="flex items-center">
                        <p className="font-bold mr-2">Year:</p>
                        <p>{product.year}</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="w-full mt-6">
                <div className="flex items-center justify-between mb-3">
                  <h2 className="text-lg font-semibold">Condition</h2>
                  <div className="relative">
                    <button
                      onClick={() => toggleDropdown("conditionInfo")}
                      className="p-0 text-black border-0"
                    >
                      <IconInfoCircle size={20} />
                    </button>
                    {openDropdown === "conditionInfo" && (
                      <div className="absolute right-0 bg-white border rounded-lg p-4 mt-2 w-64 shadow-lg z-10 text-sm">
                        {product?.type === "clothing" ? (
                          <>
                            <p>
                              <strong>New with Tags</strong>: Unused, with
                              original tags.
                            </p>
                            <p className="mt-2">
                              <strong>Excellent</strong>: Like new with no
                              visible defects.
                            </p>
                            <p className="mt-2">
                              <strong>Good</strong>: May have minor defects.
                            </p>
                            <p className="mt-2">
                              <strong>Fair</strong>: Signs of use.
                            </p>
                          </>
                        ) : (
                          <>
                            <p>
                              <strong>New</strong>: Unused, in perfect
                              condition.
                            </p>
                            <p className="mt-2">
                              <strong>Excellent</strong>: Like new with no
                              visible defects.
                            </p>
                            <p className="mt-2">
                              <strong>Good</strong>: May have minor defects.
                            </p>
                            <p className="mt-2">
                              <strong>Fair</strong>: Signs of use.
                            </p>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="border rounded-lg p-2 md:p-4 flex justify-between gap-2 md:gap-4">
                  <ConditionCircle
                    condition="fair"
                    label="FAIR"
                    isActive={product?.condition === "regular"}
                  />

                  <ConditionCircle
                    condition="good"
                    label="GOOD"
                    isActive={product?.condition === "good"}
                  />

                  <ConditionCircle
                    condition="excellent"
                    label="EXCELLENT"
                    isActive={product?.condition === "excellent"}
                  />

                  <ConditionCircle
                    condition="new"
                    label="NEW"
                    isActive={product?.condition === "new"}
                  />
                </div>
              </div>
              <div className="mt-6">
                {product?.quantity > 0 ? (
                  <div className="flex items-center space-x-2 text-black">
                    <IconCheck className="h-5 w-5 text-green-500" />

                    <span>Available - {product.quantity} in stock</span>
                  </div>
                ) : (
                  <div className="flex items-center space-x-2 text-red-500">
                    <IconX className="h-5 w-5" />
                    <span>Sold Out</span>
                  </div>
                )}
              </div>

              {product?.bibliography &&
                (() => {
                  let bibliographyArray = [];
                  if (typeof product.bibliography === "string") {
                    try {
                      bibliographyArray = JSON.parse(product.bibliography);
                    } catch (error) {
                      console.error("Error parsing bibliography:", error);
                    }
                  } else {
                    bibliographyArray = product.bibliography;
                  }
                  return bibliographyArray.length > 0 ? (
                    <div className="mt-6">
                      <div className="border rounded-lg">
                        <button
                          onClick={() => setIsAccordionOpen(!isAccordionOpen)}
                          className="w-full text-left px-4 py-2 bg-gray-100 flex justify-between items-center"
                        >
                          <span>Bibliography</span>
                          {isAccordionOpen ? (
                            <IconMinus size={20} />
                          ) : (
                            <IconPlus size={20} />
                          )}
                        </button>
                        {isAccordionOpen && (
                          <div className="px-4 py-2">
                            {bibliographyArray.map((entry, index) => (
                              <div key={index} className="flex flex-col py-1">
                                <span className="font-bold">{entry.title}</span>
                                <Link
                                  to={entry.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-blue-500 underline"
                                >
                                  {entry.url}
                                </Link>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  ) : null;
                })()}

              <div className="mt-6">
                {product?.quantity > 0 && (
                  <button
                    //onClick={buyNow}
                    className="w-full py-3 bg-custom-green-button text-white rounded-lg"
                  >
                    Buy Now in Process
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {isChatOpen && (
        <div className="fixed bottom-4 right-4 z-50">
          <ChatBubble
            onClose={() => setIsChatOpen(false)}
            productId={product.id}
          />
        </div>
      )}
      {isModalOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
          onClick={toggleModal}
        >
          <div
            className="bg-white p-6 rounded-lg shadow-lg max-w-md mx-4"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-xl font-semibold mb-2">Product Verified</h2>
            <p className="text-gray-700 mb-4">
              This product has been verified using advanced methods:
            </p>
            <ul className="list-disc pl-5 text-gray-700 text-sm space-y-1">
              <li>
                <strong>AI Image Analysis:</strong> Compares the piece with
                historical databases, detecting aging patterns, textures, and
                materials.
              </li>
              <li>
                <strong>Material Recognition:</strong> Uses spectroscopy and
                computer vision to verify if the materials match the declared
                era.
              </li>
              <li>
                <strong>Aging Pattern Analysis:</strong> Detects microcracks,
                patinas, and natural or artificial oxidation.
              </li>
              <li>
                <strong>Blockchain & Digital Certification:</strong> Registers
                verified pieces on blockchain to prevent fraud and track
                provenance.
              </li>
              <li>
                <strong>AI Predictive Models:</strong> Algorithms detect the
                probability of forgery based on historical data.
              </li>
              <li>
                <strong>Museum Database Comparison:</strong> Accesses archives
                from the Louvre, MET, and other museums to verify similarities.
              </li>
            </ul>
            <button
              onClick={toggleModal}
              className="mt-4 px-4 py-2 bg-green-500 text-white rounded-lg"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  product: state.Products.product,
});

export default connect(mapStateToProps, { get_product, add_item })(
  ProductDetail
);
